import {
  ICICILombard,
  IFFCOTokio,
  BhartiAxa,
  HDFCERGO,
  BajajAllianz,
  BirlaSunlife,
  CareHealth,
  Chola,
  Digit,
  // ICICIPrudential,
  // Kotak,
  // LIC,
  National,
  NewIndia,
  Niva,
  // PNBMetLife,
  RoyalSundaram,
  SBIGeneral,
  STARHealth,
  TATAAIG,
  OrientalInsurance,
  UnitedIndia,
} from '@prishapolicy/w3/assets';

export const formType = {
  ClaimForm: 'Claim Form',
  PolicyBrochure: 'Policy Brochure',
  PolicyWording: 'Policy Wording',
  ProposalForm: 'Proposal Form',
};

export const ICICI_LOMBARD = 'ICICI Lombard';
export const IFFCO_TOKIO = 'Iffco Tokio';
export const BAJAJ = 'Bajaj';
export const RELIANCE = 'Reliance';
export const SBI = 'SBI';
export const BHARTI_AXA = 'Bharti AXA';
export const CHOLA_MS = 'CHOLA MS';
export const NATIONAL = 'National';
export const TATA_AIG = 'Tata AIG';
export const NEW_INDIA = 'New India';
export const UNIVERSAL_SOMPO = 'Universal Sompo';
export const HDFC_ERGO = 'HDFC ERGO';
export const UNITED_INDIA = 'United India';
export const FUTURE_GENERALI = 'Future Generali';
export const LNT = 'L&T';
export const LIBERTY = 'Liberty';
export const ROYAL_SUNDARAM = 'Royal Sundaram';
export const ORIENTAL_INSURANCE = 'Oriental Insurance';
export const SHRIRAM = 'Shriram';
export const DIGIT = 'Digit';
export const CARE = 'Care';
export const NIVA_BUPA_MAX = 'Niva Bupa (Max)';
export const STAR_HEALTH = 'Star Health';
export const ADITYA_BIRLA = 'Aditya Birla';

export type InsurerLogoType = {
  [key: string]: () => JSX.Element;
};
export const insurerLogos: InsurerLogoType = {
  [ICICI_LOMBARD]: ICICILombard,
  [HDFC_ERGO]: HDFCERGO,
  [BHARTI_AXA]: BhartiAxa,
  [IFFCO_TOKIO]: IFFCOTokio,
  [BAJAJ]: BajajAllianz,
  [ADITYA_BIRLA]: BirlaSunlife,
  [CARE]: CareHealth,
  [CHOLA_MS]: Chola,
  [DIGIT]: Digit,
  [NATIONAL]: National,
  [NEW_INDIA]: NewIndia,
  [NIVA_BUPA_MAX]: Niva,
  [ROYAL_SUNDARAM]: RoyalSundaram,
  [SBI]: SBIGeneral,
  [STAR_HEALTH]: STARHealth,
  [TATA_AIG]: TATAAIG,
  [ORIENTAL_INSURANCE]: OrientalInsurance,
  [UNITED_INDIA]: UnitedIndia,
};
export type ResourceProductsType = {
  formType: string;
  formLink: string;
  description?: string;
};

export type ResourceProductType = {
  [key: string]: {
    [key: string]: ResourceProductsType[];
  };
};

export const ADVANCE_LOSS_OF_PROFIT = 'Advance Loss Of Profit';

export const TWO_WHEELER = 'Two Wheeler';
export const PRIVATE_CAR = 'Private Car';
export const COMMERCIAL_VEHICLE = 'Commercial Vehicle';
// export const
export const MARINE_CARGO = 'Marine Cargo';
export const IMPORT_EXPORT = 'Import/Export';
export const SALES_TURNOVER_POLICY = 'Sales Turnover Policy';

export const CGL = 'Commercial General Liability';
export const DOL = 'Directors and Officers Liability';
export const EMPLOYMENT_PRACTICES = 'Employment Practices';
export const PUBLIC_LIABILITY = 'Public Liability';
export const WORKMEN_COMPENSATION = 'Workmen Compensation';
export const ERRORS_AND_OMISSIONS = 'Errors & Omissions';
export const FIRE_INSURANCE = 'Fire Insurance';
export const FIRE_LOSS_OF_PROFIT = 'Fire Loss of Profit';

export const BOILER_PLANT_AND_MACHINERY = 'Boiler Plant and Machinery';
export const CONTRACTOR_ALL_RISK = 'Contractor All Risk';
export const CONTRACTORS_PLANT_AND_MACHINERY = 'Contractors Plant and Machinery';
export const ELECTRONIC_EQUIPMENT = 'Electronic Equipment';
export const ERECTION_ALL_RISK = 'Erection All Risk';
export const INDUSTRIAL_ALL_RISK = 'Industrial All Risk';
export const MACHINERY_BREAKDOWN = 'Machinery Breakdown';

export const CRITICAL_ILLNESS = 'Critical Illness';
export const HEALTH_CARE_SUPREME = 'Health Care Supreme';
export const HEALTH_ENSURE_FAMILY_PLAN = 'Health Ensure Family Plan';
export const HEALTH_GUARD = 'Health Guard';
export const CRITI_CARE = 'Criti Care';
export const COMPLETE_HEALTH = 'Complete Health';
export const OPTIMA_RESTORE = 'Optima  Restore';
export const OPTIMA_SECURE = 'Optima  Secure';
export const MY_HEALTH_PLUS_SURAKSHA = 'My Health + Suraksha';
export const ELITE_PLUS = 'Elite Plus';
export const ELITE = 'Elite';
export const SHIELD = 'Shield';
export const SHIELD_PLUS = 'Shield Plus';
export const FAMILY_HEALTH_PROTECTOR = 'Family Health Protector';
export const CARE_SENIOR = 'Care Senior';
export const SMART = 'Smart';
export const ACTIV_CARE_CLASSIC = 'Activ Care Classic';
export const ACTIV_CARE_PREMIER = 'Activ Care Premier';
export const ACTIV_CARE_STANDARD = 'Activ Care Standard';
export const ACTIV_HEALTH_PLATINUM_ENHANCED = 'Activ Health Platinum Enhanced';
export const ACTIV_HEALTH_PLATINUM_ESSENTIAL = 'Activ Health Platinum Essential';
export const ACTIV_ASSURED_DIAMOND = 'Activ Assured Diamond';
export const RE_ASSURE = 'ReAssure';
export const SENIOR_FIRST = 'Senior First';
